var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7467 11.898H9.02668C8.61268 11.898 8.27668 11.562 8.27668 11.148C8.27668 10.734 8.61268 10.398 9.02668 10.398H15.7467C16.1607 10.398 16.4967 10.734 16.4967 11.148C16.4967 11.562 16.1607 11.898 15.7467 11.898ZM12.3597 15.8H8.97368C8.55968 15.8 8.22368 15.464 8.22368 15.05C8.22368 14.636 8.55968 14.3 8.97368 14.3H12.3597C12.7737 14.3 13.1087 14.636 13.1087 15.05C13.1087 15.464 12.7737 15.8 12.3597 15.8ZM19.0197 5.87298C17.2267 4.07498 14.8427 3.08398 12.3037 3.08398C9.76368 3.08398 7.37668 4.07498 5.58368 5.87298C2.77768 8.68898 2.01268 13.01 3.67068 16.603C3.86168 17.079 3.98668 17.412 3.98668 17.694C3.98668 18.027 3.84568 18.443 3.70868 18.845C3.44368 19.624 3.14268 20.508 3.78668 21.153C4.43368 21.802 5.31768 21.498 6.09868 21.227C6.49568 21.09 6.90568 20.949 7.22968 20.947C7.52168 20.947 7.88668 21.094 8.30968 21.265C9.57868 21.852 10.9337 22.137 12.2807 22.137C14.7577 22.137 17.2037 21.172 19.0197 19.35C22.7237 15.634 22.7237 9.58798 19.0197 5.87298Z",
    fill: "#717171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.ee2d17bbdefab56a58318d07b6c446e0.svg";
export { ForwardRef as ReactComponent };